import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "detail-info-row" }
const _hoisted_2 = { class: "detail-info-pair" }
const _hoisted_3 = { class: "detail-info-pair__label" }
const _hoisted_4 = { class: "detail-info-pair__value" }
const _hoisted_5 = { class: "detail-info-pair" }
const _hoisted_6 = { class: "detail-info-pair__label" }
const _hoisted_7 = { class: "detail-info-pair__value" }
const _hoisted_8 = {
  key: 0,
  class: "detail-info-row"
}
const _hoisted_9 = { class: "detail-info-pair" }
const _hoisted_10 = { class: "detail-info-pair__label" }
const _hoisted_11 = { class: "detail-info-pair__value" }
const _hoisted_12 = { class: "detail-info-pair" }
const _hoisted_13 = { class: "detail-info-pair__label" }
const _hoisted_14 = { class: "detail-info-pair__value" }
const _hoisted_15 = { class: "ms-2 font-bold" }
const _hoisted_16 = { class: "detail-info-row" }
const _hoisted_17 = { class: "detail-info-pair" }
const _hoisted_18 = { class: "detail-info-pair__label" }
const _hoisted_19 = { class: "detail-info-pair__value" }
const _hoisted_20 = { class: "detail-info-pair" }
const _hoisted_21 = { class: "detail-info-pair__label" }
const _hoisted_22 = { class: "detail-info-pair__value" }
const _hoisted_23 = { class: "detail-info-row" }
const _hoisted_24 = { class: "detail-info-pair" }
const _hoisted_25 = { class: "detail-info-pair__label" }
const _hoisted_26 = { class: "detail-info-pair__value" }
const _hoisted_27 = { class: "detail-info-pair" }
const _hoisted_28 = { class: "detail-info-pair__label" }
const _hoisted_29 = { class: "detail-info-pair__value" }
const _hoisted_30 = { class: "detail-info-row detail-info-row--single" }
const _hoisted_31 = { class: "detail-info-pair" }
const _hoisted_32 = { class: "detail-info-pair__label" }
const _hoisted_33 = { class: "detail-info-pair__value" }
const _hoisted_34 = { class: "detail-status-panel" }
const _hoisted_35 = { class: "detail-status-item" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "detail-status-item__label" }, "Thủ kho duyệt", -1)
const _hoisted_37 = {
  key: 0,
  class: "form-text text-muted mb-0 mt-1"
}
const _hoisted_38 = { class: "detail-status-item" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "detail-status-item__label" }, "GĐ ký", -1)
const _hoisted_40 = { class: "detail-status-item" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "detail-status-item__label" }, "Hoàn thành", -1)
const _hoisted_42 = {
  key: 0,
  class: "form-text text-muted mb-0 mt-1"
}

import { useStore } from "vuex";
import { computed, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { HopDongService } from "@/core/services/HopDong.service";
import {
  IHopDongResponseBase,
  IPhieuNhapKhoResponseBase,
  IVatTuResponseBase,
} from "@/core/interfaces/ApiResponses";
import { PhieuNhapKhoService } from "@/core/services/PhieuNhapKho.service";
import {
  setBreadcrumbLinks,
  setCurrentPageTitle,
} from "@/core/helpers/breadcrumb";
import {
  swalErrNotification,
  getDuyetPhieuNhapXuatStatus,
  swalConfirm,
  swalNotification,
} from "@/core/helpers/utils";
import { useButtonCustom } from "@/core/hooks/use-button-custom";
import { useDateTime } from "@/core/hooks/use-date-time-hook";
import moment from "moment";
import { useLoading } from "@/core/hooks/use-loading";
import { PhieuNhapXuatStatusEnum } from "@/core/enums/phieuNhapXuatStatus.enum";
import ButtonCustom from "@/components/shared/buttons/ButtonCustom.vue";
import { openBienBanKiemNghiemPdf } from "@/components/shared/pdf-viewer/open-bien-ban-kiem-nghiem-pdf";
import { openPhieuNhapKhoPdf } from "@/components/shared/pdf-viewer/open-phieu-nhap-kho-pdf";
import LabelCustom from "@/components/shared/label-custom/LabelCustom.vue";
import PageContentBase from "@/layout/_shared/PageContentBase.vue";
import PageContentSection from "@/layout/_shared/PageContentSection.vue";
import PageHeaderActions from "@/layout/header/PageHeaderActions.vue";
import PageHeaderActionItem from "@/layout/header/PageHeaderActionItem.vue";
import PageHeaderApprovals from "@/layout/header/PageHeaderApprovals.vue";
import DanhSachVatTuTable from "@/views/crafted/pages/vat-tu/danh-sach-vat-tu-table/DanhSachVatTuTable.vue";
import useHopDong from "@/core/hooks/use-hop-dong";
import usePhieuNhap from "@/core/hooks/usePhieuNhap";
import usePermission from "@/core/hooks/usePermission";
import { useRouterCustom } from "@/core/hooks/use-router-custom";
import BaseLink from "@/components/shared/base-link/BaseLink.vue";
import ConfirmHoanThanh from "@/components/shared/confirm-hoan-thanh-modal/ConfirmHoanThanh.vue";
import Can from "@/components/Can.vue";
import { PHIEU_NHAP_KHO } from "@/core/constants/permissions";
import DetailTopicLottie from "@/components/shared/detail-topic-lottie/DetailTopicLottie.vue";
import {
  faCheckDouble,
  faCheckToSlot,
  faPencil,
  faPrint,
} from "@fortawesome/free-solid-svg-icons";
import { faTrashCan as faTrash } from "@fortawesome/free-regular-svg-icons";


export default /*#__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

const route = useRoute();
const idPhieuNhapKho = computed(
  () => Number(route.params.idPhieuNhapKho ?? route.params.id) || 0
);
const router = useRouter();
const { goBack } = useRouterCustom();

const { ButtonsType, ButtonTypeColors } = useButtonCustom();
const phieuNhapDetail = ref<IPhieuNhapKhoResponseBase | null>(null);
const { formatDisplayingDate } = useDateTime();
const { endLoading, startLoading } = useLoading();
const { editable, goToEditPhieuNhap } = usePhieuNhap();
const showEdit = computed(() => editable(phieuNhapDetail.value));
const { canDuyetPnk } = usePermission();

const showXacNhanPhieuNhap = computed(() => {
  if (!canDuyetPnk.value || !phieuNhapDetail.value?.processing_status) {
    return false;
  }

  return getDuyetPhieuNhapXuatStatus(phieuNhapDetail.value.processing_status)
    .isDisplay;
});

const showKyGdPhieuNhap = computed(
  () =>
    Boolean(phieuNhapDetail.value) &&
    canDuyetPnk.value &&
    !phieuNhapDetail.value?.is_admin_signed
);

const hasApprovalActions = computed(
  () => showXacNhanPhieuNhap.value || showKyGdPhieuNhap.value
);

const fetchPhieuNhapKho = async () => {
  try {
    const {
      data: { data },
    } = await PhieuNhapKhoService.get(idPhieuNhapKho.value);

    phieuNhapDetail.value = data;
  } catch (e) {
    await endLoading();

    await swalErrNotification(e, "Có lỗi xảy ra");
  }
};

const hopDongDetail = ref<IHopDongResponseBase | null>(null);
const selectingPhieuNhap = ref<IPhieuNhapKhoResponseBase | null>(null);
const isApprovalFlow = ref(false);

const fetchHopDong = async () => {
  if (phieuNhapDetail.value?.id_hop_dong) {
    const {
      data: { data },
    } = await HopDongService.fetchContractDetail(
      phieuNhapDetail.value.id_hop_dong
    );

    hopDongDetail.value = data;
  }
};

const isHoanThanh = computed<boolean>(
  () => !!phieuNhapDetail.value?.hoan_thanh
);

const thuKhoDuyetHelpText = computed(() => {
  const detail = phieuNhapDetail.value;
  if (!detail?.is_approved || !detail.approved_at) return "";

  const approvedAt = moment(detail.approved_at);
  if (!approvedAt.isValid()) return "";

  const approverName =
    detail.NguoiDuyet?.ho_va_ten ||
    detail.nguoi_duyet?.ho_va_ten ||
    "-";

  return `Duyệt lúc ${approvedAt.format("DD/MM/YYYY HH:mm")} bởi ${approverName}`;
});

const openBienBanPdfViewer = () => {
  openBienBanKiemNghiemPdf(
    router,
    phieuNhapDetail.value?.id_bien_ban_kiem_nghiem
  );
};

const openPhieuNhapKhoPdfViewer = () => {
  openPhieuNhapKhoPdf(router, phieuNhapDetail.value?.id);
};

onMounted(async () => {
  await startLoading();
  await fetchPhieuNhapKho();
  await fetchHopDong();
  await endLoading();
  document.title = `${
    phieuNhapDetail.value?.so_phieu ?? "Chi tiết phiếu nhập kho"
  } - Phiếu nhập kho - Đường sắt Hà Nội`;

  if (phieuNhapDetail.value?.id_hop_dong) {
    setBreadcrumbLinks([
      {
        text: "Hợp đồng",
        routeData: {
          name: "chi-tiet-hop-dong",
          params: {
            id: phieuNhapDetail.value.id_hop_dong ?? "",
          },
        },
      },
      {
        text: "Phiếu nhập kho",
      },
    ]);
  } else if (phieuNhapDetail.value) {
    setBreadcrumbLinks([
      {
        text: "Kho",
        routeData: {
          name: "chi-tiet-kho",
          params: {
            id: phieuNhapDetail.value.id_kho ?? "",
          },
        },
      },
      {
        text: "Phiếu nhập kho",
      },
    ]);
  }

  setCurrentPageTitle(
    `PNK ${phieuNhapDetail.value?.so_phieu} - ${phieuNhapDetail.value?.kho.ten_kho}`
  );
});

const taiKhoanDisplay = computed(
  () =>
    `${phieuNhapDetail.value?.ma_tk_co}/${phieuNhapDetail.value?.ma_ct_co} - ${phieuNhapDetail.value?.ten_tk_co}`
);

const vatTuItems = computed<IVatTuResponseBase[]>(() => {
  if (!phieuNhapDetail.value) return [];

  return phieuNhapDetail.value.vat_tu_nhap_kho.map((vatTu) => {
    return {
      ...vatTu,
      don_gia: vatTu.pivot.don_gia,
      so_luong: vatTu.pivot.so_luong,
    };
  });
});

const { loaiHopDong } = useHopDong();

const openApproveDialog = () => {
  if (phieuNhapDetail.value) {
    selectingPhieuNhap.value = phieuNhapDetail.value;
    isApprovalFlow.value = true;
  }
};

const confirmHoanThanh = async () => {
  selectingPhieuNhap.value = null;
  isApprovalFlow.value = false;
  await fetchPhieuNhapKho();
};

const confirmDelete = async () => {
  if (!phieuNhapDetail.value) return;

  const confirmed = await swalConfirm({
    title: `Phiếu nhập số ${phieuNhapDetail.value.so_phieu}`,
    text: "Bạn có chắc muốn xoá dữ liệu này?",
    icon: "warning",
    confirmButtonText: "Xoá",
    confirmButtonClass: "btn btn-danger",
  });

  if (!confirmed) return;

  try {
    await startLoading();
    await PhieuNhapKhoService.delete(phieuNhapDetail.value.id);
    await endLoading();
    await swalNotification("Xoá phiếu nhập kho thành công");
    goBack();
  } catch (e) {
    await endLoading();
    await swalErrNotification(e, "Có lỗi xảy ra khi xoá phiếu nhập kho");
  }
};

const { commit } = useStore();

const handleAdminSignPhieuNhap = () => {
  if (!phieuNhapDetail.value || phieuNhapDetail.value.is_admin_signed) return;

  const phieuNhapId = phieuNhapDetail.value.id;

  commit("ConfirmationDialogModule/setDialog", {
    title: `Phiếu nhập số ${phieuNhapDetail.value.so_phieu}`,
    message: "Xác nhận giám đốc ký duyệt phiếu nhập này?",
    onConfirm: async () => {
      commit("ConfirmationDialogModule/closeDialog");
      await startLoading();

      try {
        const {
          data: { data, message },
        } = await PhieuNhapKhoService.adminSign(phieuNhapId, {
          is_admin_signed: true,
        });
        if (phieuNhapDetail.value && data) {
          phieuNhapDetail.value = {
            ...phieuNhapDetail.value,
            is_admin_signed: !!data.is_admin_signed,
          };
        }
        await endLoading();
        await swalNotification(
          message || "Giám đốc ký duyệt phiếu nhập thành công"
        );
        await fetchPhieuNhapKho();
      } catch (e) {
        await endLoading();
        await swalErrNotification(e, "Có lỗi xảy ra");
      }
    },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ConfirmHoanThanh, {
      for: 'phieu_nhap',
      "phieu-nhap-data": selectingPhieuNhap.value,
      show: !!selectingPhieuNhap.value,
      "is-approval-flow": isApprovalFlow.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (selectingPhieuNhap.value = null)),
      onConfirm: confirmHoanThanh
    }, null, 8, ["phieu-nhap-data", "show", "is-approval-flow"]),
    (hasApprovalActions.value)
      ? (_openBlock(), _createBlock(PageHeaderApprovals, { key: 0 }, {
          default: _withCtx(() => [
            (showXacNhanPhieuNhap.value && phieuNhapDetail.value)
              ? (_openBlock(), _createBlock(PageHeaderActionItem, {
                  key: 0,
                  variant: "warning",
                  disabled: 
        _unref(getDuyetPhieuNhapXuatStatus)(phieuNhapDetail.value.processing_status)
          .isDisabled
      ,
                  onClick: openApproveDialog
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: _unref(faCheckDouble) }, null, 8, ["icon"])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" Xác nhận phiếu nhập kho ")
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true),
            (showKyGdPhieuNhap.value)
              ? (_openBlock(), _createBlock(Can, {
                  key: 1,
                  all: [_unref(PHIEU_NHAP_KHO).DUYET]
                }, {
                  default: _withCtx(() => [
                    _createVNode(PageHeaderActionItem, {
                      variant: "success",
                      onClick: handleAdminSignPhieuNhap
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: _unref(faCheckToSlot) }, null, 8, ["icon"])
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" Giám đốc ký duyệt ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["all"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (phieuNhapDetail.value)
      ? (_openBlock(), _createBlock(PageHeaderActions, { key: 1 }, {
          default: _withCtx(() => [
            (!phieuNhapDetail.value.is_approved)
              ? (_openBlock(), _createBlock(Can, {
                  key: 0,
                  all: [_unref(PHIEU_NHAP_KHO).XOA]
                }, {
                  default: _withCtx(() => [
                    _createVNode(PageHeaderActionItem, {
                      variant: "danger",
                      onClick: confirmDelete
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: _unref(faTrash) }, null, 8, ["icon"])
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" Xoá phiếu nhập kho ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["all"]))
              : _createCommentVNode("", true),
            (
        showEdit.value &&
        phieuNhapDetail.value.processing_status === _unref(PhieuNhapXuatStatusEnum).PENDING
      )
              ? (_openBlock(), _createBlock(PageHeaderActionItem, {
                  key: 1,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push(_unref(goToEditPhieuNhap)(phieuNhapDetail.value))))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: _unref(faPencil) }, null, 8, ["icon"])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" Chỉnh sửa ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(PageHeaderActionItem, { onClick: openPhieuNhapKhoPdfViewer }, {
              icon: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: _unref(faPrint) }, null, 8, ["icon"])
              ]),
              default: _withCtx(() => [
                _createTextVNode(" In phiếu nhập kho ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(PageContentBase, { plain: "" }, {
      default: _withCtx(() => [
        (phieuNhapDetail.value)
          ? (_openBlock(), _createBlock(PageContentSection, { key: 0 }, {
              header: _withCtx(() => [
                _createTextVNode("Chi tiết")
              ]),
              illustration: _withCtx(() => [
                _createVNode(DetailTopicLottie, { topic: "phieu-nhap" })
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode("ID:")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(LabelCustom, { "is-bolder": "" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(phieuNhapDetail.value.id), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode("Số phiếu:")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(LabelCustom, { "is-bolder": "" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(phieuNhapDetail.value.so_phieu ?? "-"), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                (phieuNhapDetail.value.id_bien_ban_kiem_nghiem)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(LabelCustom, { "is-text-muted": true }, {
                            default: _withCtx(() => [
                              _createTextVNode("B/b kiểm nghiệm:")
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(ButtonCustom, {
                            "button-type": _unref(ButtonsType).PRINT,
                            "color-type": _unref(ButtonTypeColors).INFO,
                            onClick: openBienBanPdfViewer
                          }, {
                            "button-label": _withCtx(() => [
                              _createTextVNode(_toDisplayString(phieuNhapDetail.value.bien_ban_kiem_nghiem?.so_bien_ban), 1)
                            ]),
                            _: 1
                          }, 8, ["button-type", "color-type"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(LabelCustom, { "is-text-muted": true }, {
                            default: _withCtx(() => [
                              _createTextVNode("Hợp đồng:")
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          (hopDongDetail.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("span", null, [
                                  _createVNode(BaseLink, {
                                    to: {
                    name: 'chi-tiet-hop-dong',
                    params: {
                      id: phieuNhapDetail.value.id_hop_dong,
                    },
                  }
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(hopDongDetail.value.so_hop_dong), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["to"])
                                ]),
                                _createElementVNode("span", _hoisted_15, " (" + _toDisplayString(_unref(loaiHopDong)(hopDongDetail.value)) + ") ", 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode("-")
                              ], 64))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode("Kho:")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      (phieuNhapDetail.value.kho)
                        ? (_openBlock(), _createBlock(BaseLink, {
                            key: 0,
                            to: {
                  name: 'chi-tiet-kho',
                  params: {
                    id: phieuNhapDetail.value.id_kho,
                  },
                }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(phieuNhapDetail.value.kho.ten_kho), 1)
                            ]),
                            _: 1
                          }, 8, ["to"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode("Tài khoản:")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(LabelCustom, { "is-bolder": "" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(phieuNhapDetail.value?.ma_ct_co ? taiKhoanDisplay.value : "-"), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode("Ngày hợp đồng:")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(LabelCustom, { "is-bolder": "" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(formatDisplayingDate)(
                  phieuNhapDetail.value?.hop_dong?.ngay_ky
                    ? new Date(phieuNhapDetail.value.hop_dong.ngay_ky)
                    : null,
                  "/"
                )), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode("Số hoá đơn:")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(LabelCustom, { "is-bolder": "" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(phieuNhapDetail.value.so_hoa_don ?? "-"), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode("Ngày hoá đơn:")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(LabelCustom, { "is-bolder": "" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(phieuNhapDetail.value.ngay_hoa_don
                ? _unref(formatDisplayingDate)(
                    new Date(phieuNhapDetail.value.ngay_hoa_don),
                    "/"
                  )
                : "-"), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createVNode(_component_el_tag, {
                      type: phieuNhapDetail.value.is_approved ? 'success' : 'info',
                      size: "small",
                      effect: "plain",
                      class: "detail-status-item__tag"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(phieuNhapDetail.value.is_approved ? "Đã duyệt" : "Chưa duyệt"), 1)
                      ]),
                      _: 1
                    }, 8, ["type"]),
                    (thuKhoDuyetHelpText.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(thuKhoDuyetHelpText.value), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createVNode(_component_el_tag, {
                      type: phieuNhapDetail.value.is_admin_signed ? 'success' : 'info',
                      size: "small",
                      effect: "plain",
                      class: "detail-status-item__tag"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(phieuNhapDetail.value.is_admin_signed ? "Đã ký" : "Chưa ký"), 1)
                      ]),
                      _: 1
                    }, 8, ["type"])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createVNode(_component_el_tag, {
                      type: isHoanThanh.value ? 'success' : 'info',
                      size: "small",
                      effect: "plain",
                      class: "detail-status-item__tag"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(isHoanThanh.value ? "Đã hoàn thành" : "Chưa hoàn thành"), 1)
                      ]),
                      _: 1
                    }, 8, ["type"]),
                    (isHoanThanh.value && phieuNhapDetail.value.ngay_hoan_thanh)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_42, " Ngày hoàn thành: " + _toDisplayString(_unref(formatDisplayingDate)(
                new Date(phieuNhapDetail.value.ngay_hoan_thanh),
                "/"
              )), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (phieuNhapDetail.value?.vat_tu_nhap_kho.length)
          ? (_openBlock(), _createBlock(PageContentSection, { key: 1 }, {
              header: _withCtx(() => [
                _createTextVNode("Vật tư")
              ]),
              default: _withCtx(() => [
                _createVNode(DanhSachVatTuTable, {
                  "cur-page": 1,
                  items: vatTuItems.value,
                  "show-price": true,
                  "show-edit-button": false,
                  "vat-tu-phieu-nhap-detail": true
                }, null, 8, ["items"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})